import React, { useEffect, useState } from "react";
import InputData from "../../atoms/input-data";
import {
  Form,
  FormGroup,
  Label,
  Row,
  Col,
  Input,
  Button,
  Table,
  Card,
} from "reactstrap";
import Icons from "../../atoms/icons";
import { cloneDeep } from "lodash";
import HelpTooltip from "../../atoms/help-tooltip";
import T from "../../atoms/translate";
import { t } from "../../../utils/utils";
export default function ConditionSelector({
  context,
  fields,
  selectors,
  logic,
  setLogic,
  inputData,
  setInputData,
  setSelectors,
  operators,
}) {
  const logicType = ["and", "or"];
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [field, setField] = useState("");
  const [inputContext, setInputContext] = useState("");
  const [operator, setOperator] = useState(operators[0]);
  const [localInputData, setLocalInputData] = useState({});
  const onUpdateSelector = (index, selector) => {
    const tmp = cloneDeep(selectors);
    updateInputData(tmp[index].left);
    updateInputData(tmp[index].right);
    tmp[index] = selector;
    setSelectors(tmp);
    setInputData(localInputData);
  };
  const onAddSelector = (selector) => {
    const tmp = cloneDeep(selectors);
    tmp.push(selector);
    setSelectors(tmp);
    setInputData(localInputData);
  };
  const updateInputData = (selector) => {
    const tmp = cloneDeep(inputData);
    const input = tmp[selector];
    if (input) {
      delete tmp[selector];
      setInputData(tmp);
    }
  };
  const onDeleteSelector = (index) => {
    //TODO: falta validaciones, para actualizar el inputData
    const tmp = cloneDeep(selectors);
    updateInputData(tmp[index].left);
    updateInputData(tmp[index].right);
    tmp.splice(index, 1);
    setSelectors(tmp);
  };
  useEffect(() => {
    if (!logic) {
      setLogic(logicType[0]);
    }
  }, [logic, logicType, setLogic]);
  const changeLeft = (input) => {
    onChangeInput(input, setField);
  };
  const changeRight = (input) => {
    onChangeInput(input, setInputContext);
  };
  const onChangeInput = (input, setter) => {
    setLocalInputData(cloneDeep(inputData));
    Object.keys(input.inputData).forEach((o) => {
      if (!Object.keys(inputData).includes(o)) {
        let tmp = inputData;
        tmp = { ...tmp, ...input.inputData };
        setLocalInputData(tmp);
      } else if (inputData[o].from !== input.inputData[o].from) {
        let tmp = inputData;
        tmp = { ...tmp, ...input.inputData };
        setLocalInputData(tmp);
      }
    });
    setter(input.data);
  };
  const changeSelect = ({ target }, setter) => {
    const values = [].filter
      .call(target.options, (o) => o.selected)
      .map((o) => o.value);
    setter(values[0]);
  };
  const clearInputs = () => {
    setField("");
    setOperator(operators[0]);
    setInputContext("");
    setSelectedIndex(null);
  };
  const updateSelector = () => {
    onUpdateSelector(selectedIndex, {
      left: field,
      right: inputContext,
      operator: operator,
    });
    clearInputs();
  };
  const onUpdate = (index, o) => {
    setSelectedIndex(index);
    setField(o.left);
    setOperator(o.operator);
    setInputContext(o.right);
  };
  const onDelete = (index) => {
    onDeleteSelector(index);
  };
  const addSelector = () => {
    onAddSelector({ left: field, right: inputContext, operator: operator });
    clearInputs();
  };
  return (
    <>
      <Form
        onSubmit={(e) => {
          e.preventDefault();
          if (selectedIndex != null) {
            updateSelector();
          } else {
            addSelector();
          }
        }}
      >
        <Row>
          <Col md={12}>
            <Card body className="border-0 box-shadow mb-4">
              <Row>
                <Col xs="12">
                  <h1 className="font-size-09 text-secondary fw-600 text-uppercase">
                    <T i18nKey="modalPropiedadesLogicaBusquedaTitulo" />
                  </h1>
                </Col>
                <Col xs="12">
                  <Row>
                    <Col md={4}>
                      <FormGroup>
                        <Label>
                          <T i18nKey="modalPropiedadesLogicaBusquedaLogica" />{" "}
                          <HelpTooltip
                            msg={
                              <p className="mb-0">
                                <T i18nKey="modalPropiedadesLogicaBusquedaAND" />
                                <br />
                                <T i18nKey="modalPropiedadesLogicaBusquedaOR" />
                              </p>
                            }
                          />
                        </Label>
                        <Input
                          type="select"
                          value={logic}
                          onChange={(e) => changeSelect(e, setLogic)}
                        >
                          {logicType.map((o, key) => (
                            <option key={key}>{o}</option>
                          ))}
                        </Input>
                      </FormGroup>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Card>
          </Col>
          <Col xs="12">
            <Card body className="border-0 box-shadow mb-4">
              <Row>
                <Col xs="12">
                  <h1 className="font-size-09 text-secondary fw-600 text-uppercase">
                    <T i18nKey="modalPropiedadesCondicionesTitulo" />
                  </h1>
                </Col>
                <Col xs="12">
                  <Row>
                    <Col md={4}>
                      {fields === "context" ? ( ///en el caso que se quieran usar variables presentes en el contexto
                        <FormGroup>
                          <Label>
                            <T i18nKey="modalPropiedadesCondicionesContexto" />{" "}
                            <HelpTooltip
                              msg={t(
                                "modalPropiedadesCondicionesContextoTooltip"
                              )}
                            />
                          </Label>
                          <InputData context={context} changeInput={changeLeft}>
                            <Input
                              type="text"
                              disabled={true}
                              value={field}
                              onChange={(e) => setField(e.target.value)}
                            />
                          </InputData>
                        </FormGroup>
                      ) : (
                        <FormGroup>
                          <Label>
                            <T i18nKey="modalPropiedadesCondicionesCampo" />{" "}
                            <HelpTooltip
                              msg={t("modalPropiedadesCondicionesCampoTooltip")}
                            />
                          </Label>
                          <Input
                            type="select"
                            value={field}
                            onChange={(e) => changeSelect(e, setField)}
                          >
                            <option value="" />
                            {fields.map((o, key) => (
                              <option key={key}>{o.name}</option>
                            ))}
                          </Input>
                        </FormGroup>
                      )}
                    </Col>
                    <Col md={4}>
                      <FormGroup>
                        <Label>
                          <T i18nKey="modalPropiedadesCondicionesOperador" />{" "}
                          <HelpTooltip
                            msg={t(
                              "modalPropiedadesCondicionesOperadorTooltip"
                            )}
                          />
                        </Label>
                        <Input
                          type="select"
                          value={operator}
                          onChange={(e) => changeSelect(e, setOperator)}
                        >
                          <option value="" />
                          {operators.map((o, key) => (
                            <option key={key}>{o}</option>
                          ))}
                        </Input>
                      </FormGroup>
                    </Col>
                    <Col md={4}>
                      <FormGroup>
                        <Label>
                          <T i18nKey="modalPropiedadesCondicionesCampo" />{" "}
                          <HelpTooltip
                            msg={t("modalPropiedadesCondicionesEntradaTooltip")}
                          />
                        </Label>
                        <InputData context={context} changeInput={changeRight}>
                          <Input
                            type="text"
                            disabled={true}
                            value={inputContext}
                            onChange={(e) => setInputContext(e.target.value)}
                          />
                        </InputData>
                      </FormGroup>
                    </Col>
                    <Col md={4} className="offset-4">
                      {selectedIndex != null ? (
                        <Button color="success" type="submit">
                          <T i18nKey="actualizar" />
                        </Button>
                      ) : (
                        <Button color="primary" type="submit">
                          <T i18nKey="agregar" />
                        </Button>
                      )}
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      </Form>
      <Row style={{ marginTop: "15px" }}>
        <Col>
          <Card body className="border-0 box-shadow mb-4">
            <Row>
              <Col xs="12">
                <h1 className="font-size-09 text-secondary fw-600 text-uppercase">
                  <T i18nKey="modalPropiedadesCondicionesTablaTitulo" />
                </h1>
              </Col>
              <Col xs="12">
                <Table bordered>
                  <thead>
                    <tr>
                      <th>
                        <T i18nKey="modalPropiedadesCondicionesTablaLogica" />
                      </th>
                      <th>
                        <T i18nKey="modalPropiedadesCondicionesTablaVariableIzquierda" />
                      </th>
                      <th>
                        <T i18nKey="modalPropiedadesCondicionesTablaOperator" />
                      </th>
                      <th>
                        <T i18nKey="modalPropiedadesCondicionesTablaVariableDerecha" />
                      </th>
                      <th>
                        <T i18nKey="editar" />
                      </th>
                      <th>
                        <T i18nKey="borrar" />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {selectors.map((o, key) => (
                      <tr key={key}>
                        <td>{logic}</td>
                        <td>{o.left}</td>
                        <td>{o.operator}</td>
                        <td>{o.right}</td>
                        <td>
                          <Button
                            size="sm"
                            color="primary"
                            onClick={() => onUpdate(key, o)}
                          >
                            <Icons
                              Config={{ size: "1.2em", color: "white" }}
                              Icon="MdCreate"
                            />
                          </Button>
                        </td>
                        <td>
                          <Button
                            size="sm"
                            color="danger"
                            onClick={() => onDelete(key)}
                          >
                            <Icons
                              Config={{ size: "1.2em", color: "white" }}
                              Icon="MdDelete"
                            />
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    </>
  );
}
